if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.mql = window.matchMedia('(min-width: 750px)');
        this.header = document.querySelector('.header-wrapper');
        const panel = this.querySelector('.localization-selector-dropdown');
        this.elements = {
          input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
          button: this.querySelector('.localization-selector-button'),
          panel: panel,
          search: this.querySelector('input[name="country_filter"]'),
          closeButton: this.querySelector('.country-selector__close-button'),
          resetButton: this.querySelector('.country-filter__reset-button'),
          searchIcon: this.querySelector('.country-filter__search-icon'),
          liveRegion: this.querySelector('#sr-country-search-results'),
        };

        this.elements.button.addEventListener('click', this.onButtonClick.bind(this));
        this.elements.button.addEventListener('focusout', this.onButtonFocusOut.bind(this));
        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

        this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
      }

      hidePanel() {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', '');
      }

      showPanel() {
        this.elements.button.setAttribute('aria-expanded', 'true');
        this.elements.panel.removeAttribute('hidden');
      }

      onButtonClick() {
        const isExpanded = this.elements.button.getAttribute('aria-expanded') === 'true';
        if (isExpanded) {
          this.hidePanel();
        } else {
          this.showPanel();
        }
      }

      onButtonFocusOut() {
        setTimeout(() => {
          if (!this.contains(document.activeElement)) {
            this.hidePanel();
          }
        });
      }

      onContainerKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;

        this.hidePanel();
        this.elements.button.focus();
      }

      onItemClick(event) {
        event.preventDefault();
        const form = this.querySelector('form');
        this.elements.input.value = event.currentTarget.dataset.value;
        if (form) form.submit();
      }
    }
  );
}

document.addEventListener('DOMContentLoaded', function() {
  var openBtn = document.getElementById('open-country-modal');
  var modal = document.getElementById('country-modal');
  if (!openBtn || !modal) return;
  var closeBtn = document.getElementById('close-country-modal');
  var bg = modal.querySelector('.cc-popup-background');

  openBtn.addEventListener('click', function(e) {
    e.preventDefault();
    modal.removeAttribute('hidden');
    modal.classList.add('cc-popup--visible');
    document.body.style.overflow = 'hidden';
  });

  function closeModal() {
    modal.setAttribute('hidden', true);
    modal.classList.remove('cc-popup--visible');
    document.body.style.overflow = '';
  }

  if (closeBtn) closeBtn.addEventListener('click', closeModal);
  if (bg) bg.addEventListener('click', closeModal);

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeModal();
  });
});
